import { Suspense } from "react";
import CanonicalLessonsBuilderPage from "@/components/admin/CanonicalLessonsBuilderPage";

export default function AdminCanonicalLessonsPage() {
    return (
        <Suspense fallback={<div className="p-4 text-sm text-slate-500">Loading canonical builder...</div>}>
            <CanonicalLessonsBuilderPage />
        </Suspense>
    );
}
